<template functional>
    <div class="card" :class="data.staticClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'Card'
    }
</script>

<style scoped lang="scss">
    .card {
        background-color: hsla(0, 0%, 100%, .75);
        color: hsl(0, 0%, 20%);
        box-shadow: 0 3px 6px hsla(0, 0%, 0%, 0.16), 0 3px 6px hsla(0, 0%, 0%, 0.23);
        margin: 1.25rem 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-wrap: nowrap;
    }
</style>
